var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCatBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2",
    "data-name": "Livello 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 562.79 440.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1a253d;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M341.58,1.25l-29.46,290.04,250.67,30.54-5.14,118.45H27.46S0,0,0,0h89.6l10.82,74.23c-.82,14.64,10.89,26.92,25.55,26.81l81,.6c12.36-.92,29.76-8.42,30.1-30.29L240.47.02l101.11,1.23Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatBlue);
export default __webpack_public_path__ + "static/media/cat-blue.8437dbf09c467ab804d492979456120e.svg";
export { ForwardRef as ReactComponent };